import styled from "styled-components";
import { Flex } from "antd";

const StylesContainer = styled(Flex)`
  background: #fff;
  border-radius: 12px;
  padding: 27px;

  h4 {
    color: #253856;
    font-size: 24px;
    line-height: 28px;
    margin: 0;
  }

  p {
    color: #1c5568;
    line-height: 20px;
    margin: 0;
  }

  .ant-btn {
    min-width: 217px;

    .ant-btn-icon {
      position: absolute;
      right: -16px;
      top: -17px;
    }
  }
`;

export default StylesContainer;
